import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Row, Col, Button } from 'react-bootstrap';

const Dashboard = () => {
  const [menuPermissions, setMenuPermissions] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const storedUserid = localStorage.getItem('userID');
    console.log("Dash"+storedUserid);
    if (!storedUserid) {
      // Redirect to login if userID is not found
     // navigate('/login');
    } else {
      // Fetch permissions (as in your current implementation)
      const fetchPermissions = async () => {
        try {
          const response = await fetch(`https://webcore.hunzagroupofindustries.com.pk/api/account/GetPer?userId=${storedUserid}`);
          if (response.ok) {
            const data = await response.json();
            setMenuPermissions(data.permissions || []);
          }
        } catch (error) {
          console.error('Error fetching permissions:', error);
        }
      };

      fetchPermissions();
    }
  }, [navigate]);

  const handleUnitClick = (unit) => {
    navigate(`/${unit}`);
  };

  const canAccessUnitI = menuPermissions.some((perm) => perm.Location === 'Unit I' && perm.CanRead === 1);
  const canAccessUnitII = menuPermissions.some((perm) => perm.Location === 'Unit II' && perm.CanRead === 1);

  return (
    <div className="mt-4">
      <h2 className="mb-4">Dashboard</h2>
      <Row>
        {canAccessUnitI && (
          <Col md={4}>
            <Card className="mb-4">
              <Card.Body>
                <Card.Title>Unit I</Card.Title>
                <Button variant="primary" onClick={() => handleUnitClick('screenI')}>
                  Go to Unit I
                </Button>
              </Card.Body>
            </Card>
          </Col>
        )}
        {canAccessUnitII && (
          <Col md={4}>
            <Card className="mb-4">
              <Card.Body>
                <Card.Title>Unit II</Card.Title>
                <Button variant="primary" onClick={() => handleUnitClick('screen')}>
                  Go to Unit II
                </Button>
              </Card.Body>
            </Card>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default Dashboard;
